import axios from 'axios';
import { logger } from '../utils/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
export { API };

// Email Lead API — accepts name and phone for higher-quality leads
export const submitEmail = async (email, name = null, phone = null) => {
  try {
    const response = await axios.post(`${API}/leads`, { email, name, phone });
    return { success: true, data: response.data };
  } catch (error) {
    logger.error('Error submitting email:', error);
    return { success: false, error: error.response?.data?.detail || 'Error al enviar email' };
  }
};

// Test Result API
export const submitTestResult = async (q1, q2, email = null) => {
  try {
    const response = await axios.post(`${API}/test-results`, { q1, q2, email });
    return { success: true, data: response.data };
  } catch (error) {
    logger.error('Error submitting test:', error);
    return { success: false, error: error.response?.data?.detail || 'Error al guardar test' };
  }
};

// Goal Calculation API
export const submitGoalCalculation = async (goalData) => {
  try {
    const response = await axios.post(`${API}/goals`, {
      goal_name: goalData.goalName,
      goal_amount: parseFloat(goalData.goalAmount),
      current_savings: parseFloat(goalData.currentSavings),
      monthly_contribution: parseFloat(goalData.monthlyContribution),
      rate: parseFloat(goalData.rate),
      email: goalData.email || null
    });
    return { success: true, data: response.data };
  } catch (error) {
    logger.error('Error submitting goal:', error);
    return { success: false, error: error.response?.data?.detail || 'Error al calcular meta' };
  }
};

// Savings Index API
export const submitSavingsIndex = async (income, autoAmount, email = null) => {
  try {
    const response = await axios.post(`${API}/savings-index`, {
      income: parseFloat(income),
      auto_amount: parseFloat(autoAmount),
      email
    });
    return { success: true, data: response.data };
  } catch (error) {
    logger.error('Error submitting savings index:', error);
    return { success: false, error: error.response?.data?.detail || 'Error al calcular índice' };
  }
};

// Growth Calculation API
export const submitGrowthCalculation = async (amount, years, rate, email = null) => {
  try {
    const response = await axios.post(`${API}/growth-calculations`, {
      amount: parseFloat(amount),
      years: parseInt(years),
      rate: parseFloat(rate),
      email
    });
    return { success: true, data: response.data };
  } catch (error) {
    logger.error('Error submitting growth calculation:', error);
    return { success: false, error: error.response?.data?.detail || 'Error al calcular crecimiento' };
  }
};

// Challenge 30 Days API
export const submitChallenge30 = async (categoryName, dailyAmount, email = null) => {
  try {
    const response = await axios.post(`${API}/challenges/30-days`, {
      category_name: categoryName,
      daily_amount: parseFloat(dailyAmount),
      email
    });
    return { success: true, data: response.data };
  } catch (error) {
    logger.error('Error submitting 30-day challenge:', error);
    return { success: false, error: error.response?.data?.detail || 'Error al registrar reto' };
  }
};

// Challenge 18 Months API
export const submitChallenge18 = async (monthlyAmount, rate, email = null) => {
  try {
    const response = await axios.post(`${API}/challenges/18-months`, {
      monthly_amount: parseFloat(monthlyAmount),
      rate: parseFloat(rate),
      email
    });
    return { success: true, data: response.data };
  } catch (error) {
    logger.error('Error submitting 18-month challenge:', error);
    return { success: false, error: error.response?.data?.detail || 'Error al registrar reto' };
  }
};

// Stats API
export const getStats = async () => {
  try {
    const response = await axios.get(`${API}/stats`);
    return { success: true, data: response.data };
  } catch (error) {
    logger.error('Error fetching stats:', error);
    return { success: false, error: 'Error al obtener estadísticas' };
  }
};
